import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Import the custom CSS
import {
  getAuth,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";

// import { auth } from "../firebase/firebase"; // Import Firebase config

function LoginScreen() {
  const firebaseConfig = {
    apiKey: "AIzaSyCCZs0KeYn-GRUHhUDjQqTdBcikNMgejSw",
    authDomain: "digital-well-424806-d4.firebaseapp.com",
    appId: "1:113404369101:web:6d1fa706ef9ff025c57184",
    messagingSenderId: "113404369101",
    projectId: "digital-well-424806-d4",
    storageBucket: "digital-well-424806-d4.appspot.com",
    measurementId: "G-0TZLGZ3BZW",
  };

  // const app = initializeApp(firebaseConfig);

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading2, setloading2] = useState(false);

  const navigate = useNavigate();

  const getData = async () => {
    const querySnapshot = await getDocs(collection(db, "schedules"));
    console.log(querySnapshot.size);
    querySnapshot.forEach((doc) => {
      console.log(doc.data());
    });
  };

  const getUserDetails = async () => {
    try {
      const auth = getAuth();
      console.log(auth);
      const user = auth.currentUser;

      if (!user) return null;

      const db = getFirestore();
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        setloading2(false);
        localStorage.setItem("loggedin", true);
        localStorage.setItem("usertype", data.userType);
        localStorage.setItem("id", data.id);
        localStorage.setItem("name", data.name);
        localStorage.setItem("email", data.email);
        getData();
        // if (localStorage.getItem("usertype") == "user") {
        //   // navigate("/management")
        // } else {
        //   // navigate("/dashboard")
        // }
        let ln = localStorage.getItem("loggedin");
        let type = localStorage.getItem("usertype");
        if (ln !== null && type !== "user") {
          navigate("/dashboard");
          console.log("11111")
        } else if (ln !== null && type === "user") {
          console.log("&&&&&")
          navigate("/management");
        } else {
          navigate("/");
        }
        console.log(userSnap.data()); // Returns user details
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    let ln = localStorage.getItem("loggedin");
    let type = localStorage.getItem("usertype");
    if (ln !== null && type !== "user") {
      navigate("/dashboard");
    } else if (ln !== null && type === "user") {
      navigate("/management");
    } else {
      navigate("/");
    }
  }, [navigate]);
  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     // Handle login logic here
  //     // For now, we'll just redirect to the dashboard page
  //     navigate("/_");
  //   };


  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Login</h2>
        <div
        // onSubmit={async()=>{
        //    if((email === "admin@admin.com" && password === "admin") ){
        //     console.log("Admin 1 login successful");
        //     const abc = await signInWithEmailAndPassword(auth, email.trim(), password);
        //     console.log(abc)
        //     // navigate("/")
        //     localStorage.setItem("loggedin", true)
        // }else if(email === "admin1@admin.com" && password === "admin1" ){
        //     console.log("Admin 2 login successful");
        //     const abc = await signInWithEmailAndPassword(auth, email.trim(), password);
        //     console.log(abc)
        //     // navigate("/")
        //     localStorage.setItem("loggedin", true)
        // }else{
        //     alert("invalid credentials");
        //     }
        // }}
        >
          <div className="input-group">
            <label htmlFor="email" className="input-label">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="input-field"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password" className="input-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="input-field"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            onClick={async () => {
              console.log(password, email);
              try {
                setloading2(true)
                     const abc = await signInWithEmailAndPassword(auth, email.trim(), password);
            console.log(abc)
            getUserDetails()
                
              } catch (error) {
                console.log(error);
                alert("invalid email or password");
                setloading2(false);
              }
            }}
            type="submit"
            style={{ color: "#000" }}
            className="submit-btn"
          >
            {loading2 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "30px",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </div>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <style>
        {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #000;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default LoginScreen;
